module.exports = __webpack_public_path__ + "svg/dice-blue.svg?94f08dd2518a56291c2f099dde472742";